module.exports = __webpack_public_path__ + "img/pos3.4d660564.jpg";